import { render, staticRenderFns } from "./TicketCheckoutCatalogItem.vue?vue&type=template&id=008fb681&scoped=true&"
import script from "./TicketCheckoutCatalogItem.vue?vue&type=script&lang=ts&"
export * from "./TicketCheckoutCatalogItem.vue?vue&type=script&lang=ts&"
import style0 from "./TicketCheckoutCatalogItem.vue?vue&type=style&index=0&id=008fb681&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008fb681",
  null
  
)

export default component.exports